import {createSlice} from '@reduxjs/toolkit';
import {NetatmoDataGranularity} from '../../api/types';
import {DAY} from '../../utils/Dates';
import {ChartConfig, ComparisonConfig} from '../../utils/NetatmoCommon';
import {Scale} from '../../utils/Time';

type Account = {
  uid: string;
  active: boolean;
  last_updated: number;
  extra_data: Record<string, unknown>;
};

type StationMetadata = {
  name: string;
};

type Metadata = {
  stations: Record<string, StationMetadata>;
};

type Link = {
  account: Account;
  date_connected: number;
  metadata: Metadata;
};

type Props = {
  link: Link | null;
  currentStation: string | null;
  chartConfig: ChartConfig;
};

export const netatmoWeatherSlice = createSlice({
  name: 'netatmoWeather',
  initialState: {
    link: null,
    currentStation: null,
    chartConfig: {
      scale: DAY,
      granularity: 'max',
      comparison: null,
    },
  } as Props,
  reducers: {
    setNetatmoWeatherUserLink: (state, {payload: link}) => {
      state.link = link;
    },
    setNetatmoWeatherAccount: (state, {payload: account}) => {
      if (state.link !== null) {
        state.link.account = account;
      }
    },
    setNetatmoWeatherCurrentStation: (state, {payload: stationid}) => {
      state.currentStation = stationid;
    },
    setNetatmoWeatherChartComparison: (
      state,
      {payload: comparisonConfig}: {payload: ComparisonConfig},
    ) => {
      state.chartConfig = {
        ...state.chartConfig,
        comparison: comparisonConfig,
      };
    },
    setNetatmoWeatherChartScale: (
      state,
      {payload: scale}: {payload: Scale},
    ) => {
      state.chartConfig = {...state.chartConfig, scale};
    },
    setNetatmoWeatherChartGranularity: (
      state,
      {payload: granularity}: {payload: NetatmoDataGranularity},
    ) => {
      state.chartConfig = {...state.chartConfig, granularity};
    },
  },
});

export const {
  setNetatmoWeatherUserLink,
  setNetatmoWeatherAccount,
  setNetatmoWeatherCurrentStation,
  setNetatmoWeatherChartComparison,
  setNetatmoWeatherChartScale,
  setNetatmoWeatherChartGranularity,
} = netatmoWeatherSlice.actions;

export default netatmoWeatherSlice.reducer;
